import ScreenUtils from '@screen';
import * as React from 'react';

const EraseIcon = ({
  width = 33,
  height = 32,
  focused = false,
}: {
  width?: number;
  height?: number;
  focused: boolean;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width * ScreenUtils.widthRatio}
    height={height * ScreenUtils.widthRatio}
    fill='none'
    viewBox={`0 0 ${width * ScreenUtils.widthRatio} ${
      height * ScreenUtils.widthRatio
    }`}
  >
    <path
      stroke={focused ? 'black' : 'white'}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='m17.056 4.708-.89 13.348c-.078 1.169-.117 1.754-.37 2.197-.222.39-.557.704-.961.9-.46.222-1.045.222-2.217.222H8.16c-1.172 0-1.758 0-2.217-.222a2.22 2.22 0 0 1-.962-.9c-.252-.443-.291-1.028-.369-2.197l-.89-13.348m-2.222 0h17.778m-4.445 0-.3-.902c-.292-.874-.438-1.311-.708-1.634a2.2 2.2 0 0 0-.891-.643c-.392-.154-.853-.154-1.774-.154H9.618c-.921 0-1.382 0-1.774.154a2.2 2.2 0 0 0-.891.643c-.27.323-.416.76-.708 1.634l-.3.902m6.666 4.445v7.778M8.167 9.153v7.778'
    ></path>
  </svg>
);

export default EraseIcon;
